import { ChangeDetectorRef, Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { environment } from '../../environments/environment';
import {isIE} from '../helpers/utils';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrl: './home.component.css',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HomeComponent implements OnInit {
  error_message!: string;
  showIEErrorMsg: boolean =  false;
  hardstop:  boolean = false;
  showErrorMsg: boolean = false;

  constructor(private changeDetectorRef: ChangeDetectorRef) {
    
  }

  onActivate(event:any) {
   window.scroll({ 
           top: 0, 
           left: 0, 
           behavior: 'smooth' 
    });
  }  
 
  triggerChangeDetection() {
    this.changeDetectorRef.detectChanges();
  }
  ngOnInit(): void {
    if (isIE()) {
      console.log('Internet Explorer detected'); // Show errror message
      this.showIEErrorMsg = true;
      this.hardstop = true;
  } else if(!navigator.cookieEnabled) {
    this.error_message = environment.APP_MESSAGE_COOKIE_DISABLED;
    this.hardstop = true;
  } else {
    this.showErrorMsg = true;
    this.error_message = environment.APP_MESSAGE_NO_FOMID;
  }
  }


  title = 'default';
  clientId: string = environment.APP_CLIENTID
}
